import React, { useState, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import logo2 from '../assets/appbar_icon.png';
import button8 from '../assets/button_8.png';
import './AppBar.css';
import { FaUser, FaBars, FaTimes, FaSignInAlt, FaArrowRight } from 'react-icons/fa';
import tracker from '../utils/tracker';

const AppBar = ({ backgroundColor }) => {
  const { user, loading, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { reportActivity } = useContext(AuthContext);

  const handleLoginClick = () => {
    tracker.track('cta_click', { cta: 'appbar_login' });
    navigate('/login');
  };
  const handleSignUpClick = () => {
    tracker.track('cta_click', { cta: 'appbar_signup' });
    navigate('/signup');
  };

  const handleDownloadClick = () => {
    tracker.track('cta_click', { cta: 'appbar_download' });
    if (user && user.planId && user.status === "active") {
      reportActivity('/wallets');
      navigate('/wallets');
    } else if (user) {
      reportActivity('/purchase');
      navigate('/purchase');
    } else {
      navigate('/signup'); // unauthenticated, no point reporting
    }
  };
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleDashboardClick = () => {
    reportActivity('/wallets'); // pass the destination, not current
    navigate('/wallets');
  };

  const appBarStyle = {
    background: backgroundColor || 'rgba(0, 0, 0, 0.748)'
  };

  return (
    <>
      <div className="app-bar" style={appBarStyle}>
        <a href="/" className="logo-wrapper">
          <img src={logo2} alt="LunaSearch Logo" draggable="false" className="logo" />
          <p draggable="false">LunaSearch</p>
        </a>

        <div className="nav-links desktop-nav">
          <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>Home</NavLink>
          <NavLink to="/guide" className={({ isActive }) => (isActive ? 'active' : '')}>Guide</NavLink>
          <NavLink to="/purchase" className={({ isActive }) => (isActive ? 'active' : '')}>Purchase</NavLink>
          <NavLink to="/affiliate" className={({ isActive }) => (isActive ? 'active' : '')}>Affiliate</NavLink>
        </div>

        <div className="auth-links desktop-auth">
          {loading ? (
            <div className="auth-placeholder-container">
              <div className="auth-placeholder" />
              <div className="auth-placeholder-profile" />
            </div>
          ) : user ? (
            <>
              <button className="purple-button-download" onClick={handleDownloadClick}>DOWNLOAD APP</button>
              <button className="profile-button" onClick={handleDashboardClick}><FaUser size={24} /></button>
            </>
          ) : (
            <>
              <button className="log-in-button" onClick={handleLoginClick}>Sign in</button>
              <button className="purple-button" onClick={handleSignUpClick}>Get Started <FaArrowRight className="arrow-icon" /></button>
            </>
          )}
        </div>

        <div className="mobile-auth-buttons">
          {!loading && (
            <>
              {user ? (
                <button className="mobile-download-button" onClick={handleDashboardClick}>
                  <FaUser size={24} />
                </button>
              ) : (
                <button className="mobile-signup-button" onClick={handleSignUpClick}>
                  <FaSignInAlt size={24} />
                </button>
              )}
               <button className="mobile-menu-button" onClick={toggleMenu}>
                {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
              </button> 
            </>
          )}
        </div>
      </div>

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`} >
        <div className="mobile-nav-links">
          <NavLink to="/" onClick={toggleMenu}>Home</NavLink>
          <NavLink to="/guide" onClick={toggleMenu}>Guide</NavLink>
          <NavLink to="/purchase" onClick={toggleMenu}>Purchase</NavLink>
          <NavLink to="/affiliate" onClick={toggleMenu}>Affiliate</NavLink>
          
          {/* Only show Log in link if user is NOT logged in */}
          {!user && <NavLink to="/login" onClick={toggleMenu}>Log in</NavLink>}
          
          <button className="mobile-menu-button-8" onClick={handleDownloadClick}>
            <img src={button8} alt="Download" draggable="false" />
          </button>
        </div>
      </div>
    </>
  );
};

export default AppBar;